import { mergeObjectTypes } from '../cacheHelpers';

const Cargo = {
  merge: mergeObjectTypes
};

export default Cargo;
